<template>
  <v-tooltip
    v-if="color"
    top
  >
    <template
      #activator="{ on, attrs }"
    >
      <div
        v-bind="attrs"
        v-on="on"
        class="circle-common"
        :style="{ backgroundColor: color }"
      />
    </template>
    <div
      v-html="tooltipText || ''"
    />
  </v-tooltip>
</template>

<script>

import { formatIsoDateCustom } from '@/global/services/helpers/dates'
const DEACTIVATED_CSS_COLOR_COLOR = '#ffb5b5'
const ALL_DAY_CSS_COLOR = '#335a94'
const PARTIAL_DAY_CSS_COLOR = '#85b4e2'
const OWN_ALL_DAY_CSS_COLOR = '#17b017'
const OWN_PARTIAL_DAY_CSS_COLOR = '#92ff92'
const FORM_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DISPLAY_DATETIME_FORMAT = 'DD.MM.YYYY. HH:mm'
export default {
  name: 'CellCircle',

  props: {
    cellData: {
      type: [Object, String, Number, Boolean],
      default: null
    },
    header: {
      type: Object,
      default: () => ({})
    },
    globalConfig: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      color: null,
      tooltipText: ''
    }
  },

  watch: {
    cellData: {
      immediate: true,
      deep: true,
      handler (val) {
        const {
          duration,
          is_own: isOwnReservation,
          isDeactivated,
          entries
        } = val || {}
        const { dayDuration } = this.globalConfig || {}

        if (entries && entries.length) {
          this.tooltipText = ''
          entries.forEach((entry, index) => {
            const isLast = index === entries.length - 1

            if (entry.deactivated_at) {
              this.tooltipText += '<span style="text-decoration: line-through;">' + (entry.driver_full_name || '') + ' ' + (entry.date_start && entry.date_end ? formatIsoDateCustom(entry.date_start, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) + ' - ' + formatIsoDateCustom(entry.date_end, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : '') + ' (' + formatIsoDateCustom(entry.deactivated_at, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) + ')' + '</span>'
            }
            else {
              this.tooltipText += '<span>' + (entry.driver_full_name || '') + ' ' + (entry.date_start && entry.date_end ? formatIsoDateCustom(entry.date_start, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) + ' - ' + formatIsoDateCustom(entry.date_end, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : '') + '</span>'
            }

            if (!isLast) {
              this.tooltipText += '<br>'
            }
          })
        }

        if (isDeactivated) {
          this.color = DEACTIVATED_CSS_COLOR_COLOR
        }
        else if (duration && dayDuration) {
          if (duration >= dayDuration) {
            if (isOwnReservation) {
              this.color = OWN_ALL_DAY_CSS_COLOR
            }
            else {
              this.color = ALL_DAY_CSS_COLOR
            }
          }
          else if (duration > 0) {
            if (isOwnReservation) {
              this.color = OWN_PARTIAL_DAY_CSS_COLOR
            }
            else {
              this.color = PARTIAL_DAY_CSS_COLOR
            }
          }
        }
        else {
          this.color = null
        }
      }
    }
  }
}
</script>

<style scoped>
@import "../styles/circleStyle.css";
</style>
